import { connect } from "react-redux";
import { makeStyles } from "@material-ui/styles";
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  Button,
  TablePagination,
  Box,
  Paper,
  CardContent,
  Modal,
  IconButton,
  TextField,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  Alert,
} from "@mui/material";
import Stack from "@mui/material/Stack";
import CloseIcon from "@mui/icons-material/Close";
import SendIcon from "@mui/icons-material/Send";
import PersonAddRounded from "@mui/icons-material/PersonAddRounded";
import { Delete, Edit, Mode } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import axios from "axios";

export const TraningModule = ({ }) => {
  const classes = useStyles();

  // Data variables
  const [TrainingModuleName, setTrainingModuleName] = useState("");
  const [description, setDescription] = useState();
  const [selectedCategoryId, setSelectedCategoryId] = useState(""); // To store Category ID
  const [categoryList, setCategoryList] = useState([]); // To store fetched categories
  const [TrainerData, setTrainerData] = useState([]);
  const [dataLoad, setDataLoad] = useState(false);
  const [trainingModule_id, setId] = useState();
  const [deleteTrainingModule, setDeleteTrainingModule] = useState();

  // Table Pagination variables
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  // Modal variables
  const [openTrainingModule, setOpenTrainingModule] = useState(false);
  const [EditTrainingModule, setEditTrainingModule] = useState(false);

  // Error variables
  const [NameError, setNameError] = useState(false);
  const [DescriptionError, setDescriptionError] = useState(false);
  const [CategoryError, setCategoryError] = useState(false);

  useEffect(() => {
    getTrainerData();
    getCategoryList(); // Fetch categories on load
  }, []);

  const getTrainerData = async () => {
    setDataLoad(true);
    await axios
      .get(
        process.env.REACT_APP_BASE_URL + "/trainingmodule/gettrainingmodulelist"
      )
      .then((res) => {
        if (res.data !== "No data found") {
          setTrainerData(res.data);
        }
        setDataLoad(false);
      })
      .catch((err) => {
        setDataLoad(false);
      });
  };

  // Fetch Categories to populate dropdown
  const getCategoryList = async () => {
    await axios
      .get(
        process.env.REACT_APP_BASE_URL +
        "/trainingsubcategory/gettrainingsubcategorylist"
      )
      .then((res) => {
        if (res.data !== "No data found") {
          setCategoryList(res.data);
        }
      })
      .catch((err) => {
        console.log("Error fetching categories", err);
      });
  };

  const foramvaliadate = () => {
    let IsformValid = true;
    if (!TrainingModuleName || TrainingModuleName.trim().length === 0) {
      IsformValid = false;
      setNameError(true);
    }

    if (!description || description.trim().length === 0) {
      IsformValid = false;
      setDescriptionError(true);
    }

    if (!selectedCategoryId) {
      IsformValid = false;
      setCategoryError(true);
    }

    return IsformValid;
  };

  const handleAdd = async () => {
    setNameError(false);
    setDescriptionError(false);
    setCategoryError(false);

    if (foramvaliadate()) {
      const selectedCat = categoryList.find(
        (cat) => cat._id === selectedCategoryId
      );
      const data = {
        trainingModuleName: TrainingModuleName,
        description: description,
        trainingCategoryId: selectedCategoryId,
        trainingCategoryName: selectedCat?.trainingCategoryName // Linking to Category
      };

      await axios
        .post(
          process.env.REACT_APP_BASE_URL + "/trainingmodule/inserttrainingmodule",
          data
        )
        .then((res) => {
          setOpenTrainingModule(false);
          getTrainerData();
        })
        .catch((err) => {
          console.log("Error adding module", err);
        });
    }
  };

  const openModule = () => {
    setTrainingModuleName("");
    setDescription("");
    setSelectedCategoryId("");
    setOpenTrainingModule(true);
  };

  const openEdit = (row) => {
    setTrainingModuleName(row?.trainingModuleName);
    setDescription(row?.description);
    // Assuming API returns trainingCategoryId as object or string. Adjust logic if populated object
    setSelectedCategoryId(row?.trainingCategoryId?._id || row?.trainingCategoryId || "");
    setId(row?._id);
    setEditTrainingModule(true);
  };

  const openDelete = (row) => {
    setId(row?._id);
    setDeleteTrainingModule(true);
  };

  const handleDelete = async () => {
    await axios
      .put(
        process.env.REACT_APP_BASE_URL + "/trainingmodule/trainingmoduledelete",
        { trainingModule_id }
      )
      .then((res) => {
        setDeleteTrainingModule(false);
        getTrainerData();
      })
      .catch((err) => {
        console.log("Error deleting", err);
      });
  };

  const handleEdit = async (e) => {
    setNameError(false);
    setDescriptionError(false);
    setCategoryError(false);

    if (foramvaliadate()) {
      const data = {
        trainingModule_id,
        trainingModuleName: TrainingModuleName,
        description,
        trainingCategoryId: selectedCategoryId,
      };

      await axios
        .put(
          process.env.REACT_APP_BASE_URL + "/trainingmodule/trainingmoduleupdate",
          data
        )
        .then((res) => {
          setEditTrainingModule(false);
          getTrainerData();
        })
        .catch((err) => {
          console.log("Error updating", err);
        });
    }
  };

  // Helper to get Category Name for Table Display
  const getCategoryName = (id) => {
    if (!id) return "N/A";
    // If id is an object (populated)
    if (typeof id === 'object' && id.trainingCategoryName) return id.trainingCategoryName;

    // If id is string, find in list
    const cat = categoryList.find((c) => c._id === id);
    return cat ? cat.trainingCategoryName : "Unknown";
  };

  return (
    <div className={classes.main}>
      <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
        <Box sx={{ flex: 1 }}>
          <h1>Training Module</h1>
        </Box>
        <Box>
          <div style={{ marginTop: 30, right: 0 }}>
            <Button variant="contained" onClick={() => openModule()}>
              <PersonAddRounded style={{ marginRight: 10 }} />
              Add Training Module
            </Button>
          </div>
        </Box>
      </div>

      {dataLoad ? (
        <CircularProgress color="primary" />
      ) : (
        <Paper sx={{ overflow: "hidden", width: "90%", marginTop: 2 }}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell style={{ fontSize: 16, textAlign: "center" }}>
                    <strong>SR No.</strong>
                  </TableCell>
                  <TableCell style={{ fontSize: 16, textAlign: "center" }}>
                    <strong>Category</strong>
                  </TableCell>
                  <TableCell style={{ fontSize: 16, textAlign: "center" }}>
                    <strong>Module Name</strong>
                  </TableCell>
                  <TableCell style={{ fontSize: 16, textAlign: "center" }}>
                    <strong>Description</strong>
                  </TableCell>
                  <TableCell style={{ fontSize: 16, textAlign: "center" }}>
                    <strong>Action</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {TrainerData.length > 0 ? (
                  TrainerData.slice(
                    page * rowsPerPage,
                    page * rowsPerPage + rowsPerPage
                  ).map((row, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell style={{ fontSize: 16, textAlign: "center" }}>
                          {index + 1}
                        </TableCell>
                        <TableCell style={{ fontSize: 16, textAlign: "center" }}>
                          {/* Display Category Name */}
                          {/* {getCategoryName(row?.categoryType)} */}
                          {row?.trainingCategoryName}
                        </TableCell>
                        <TableCell style={{ fontSize: 16, textAlign: "center" }}>
                          {row?.trainingModuleName}
                        </TableCell>
                        <TableCell style={{ fontSize: 16, textAlign: "center" }}>
                          {row?.description}
                        </TableCell>
                        <TableCell style={{ fontSize: 16, textAlign: "center" }}>
                          <Edit
                            variant="contained"
                            style={{ color: "green", cursor: "pointer" }}
                            onClick={() => openEdit(row)}
                          />
                          <Delete
                            variant="contained"
                            style={{ color: "red", cursor: "pointer" }}
                            onClick={() => openDelete(row)}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow>NO Data Found</TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={TrainerData?.length > 0 ? TrainerData?.length : 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={(e, newPage) => setPage(newPage)}
            onRowsPerPageChange={(e) => {
              setRowsPerPage(+e.target.value);
              setPage(0);
            }}
          />
        </Paper>
      )}

      {/* Add Training Module */}
      <Modal
        className={classes.middlePosition}
        open={openTrainingModule}
        onClose={() => setOpenTrainingModule(false)}
      >
        <Paper className={classes.profilemodal}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
          >
            <Typography variant="h6" component="div">
              Add Training Module
            </Typography>
            <IconButton onClick={() => setOpenTrainingModule(false)}>
              <CloseIcon />
            </IconButton>
          </Stack>
          <div className={classes.modalContent}>
            <CardContent className={classes.cardContent}>

              {/* Category Dropdown */}
              <FormControl sx={{ m: 1, width: "97%" }}>
                <InputLabel>Select Category</InputLabel>
                <Select
                  value={selectedCategoryId}
                  label="Select Category"
                  onChange={(e) => setSelectedCategoryId(e.target.value)}
                  error={CategoryError}
                >
                  {categoryList.map((cat) => (
                    <MenuItem key={cat._id} value={cat._id}>
                      {cat.trainingSubjectCategoryName} ({cat.categoryType === "Theory" ? "सैद्धांतिक" : cat.categoryType === "Practical" ? "प्रात्यक्षिक" : cat.categoryType})
                    </MenuItem>
                  ))}
                </Select>
                {CategoryError && <span style={{ color: "red", fontSize: 12 }}>* Please Select Category</span>}
              </FormControl>

              <FormControl sx={{ m: 1, width: "97%" }}>
                <TextField
                  error={NameError}
                  label="Training Module Name"
                  value={TrainingModuleName}
                  onChange={(e) => setTrainingModuleName(e.target.value)}
                  helperText={NameError ? "Please Enter Module Name" : null}
                />
              </FormControl>

              <FormControl sx={{ m: 1, width: "97%" }}>
                <TextField
                  label="Description"
                  multiline
                  rows={2}
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  helperText={DescriptionError ? "Please Enter Description" : null}
                  error={DescriptionError}
                />
              </FormControl>
            </CardContent>

            <Button
              variant="contained"
              style={{ margin: 10 }}
              endIcon={<SendIcon />}
              onClick={handleAdd}
            >
              ADD Module
            </Button>
          </div>
        </Paper>
      </Modal>

      {/* Update Training Module */}
      <Modal
        className={classes.middlePosition}
        open={EditTrainingModule}
        onClose={() => setEditTrainingModule(false)}
      >
        <Paper className={classes.profilemodal}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
          >
            <Typography variant="h6" component="div">
              Update Training Module
            </Typography>
            <IconButton onClick={() => setEditTrainingModule(false)}>
              <CloseIcon />
            </IconButton>
          </Stack>
          <div className={classes.modalContent}>
            <CardContent className={classes.cardContent}>

              <FormControl sx={{ m: 1, width: "97%" }}>
                <InputLabel>Select Category</InputLabel>
                <Select
                  value={selectedCategoryId}
                  label="Select Category"
                  onChange={(e) => setSelectedCategoryId(e.target.value)}
                  error={CategoryError}
                >
                  {categoryList.map((cat) => (
                    <MenuItem key={cat._id} value={cat._id}>
                      {cat.trainingCategoryName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl sx={{ m: 1, width: "97%" }}>
                <TextField
                  error={NameError}
                  label="Training Module Name"
                  value={TrainingModuleName}
                  onChange={(e) => setTrainingModuleName(e.target.value)}
                  helperText={NameError ? "Please Enter Module Name" : null}
                />
              </FormControl>

              <FormControl sx={{ m: 1, width: "97%" }}>
                <TextField
                  label="Description"
                  multiline
                  rows={2}
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  helperText={DescriptionError ? "Please Enter Description" : null}
                  error={DescriptionError}
                />
              </FormControl>
            </CardContent>

            <Button
              variant="contained"
              style={{ margin: 10 }}
              endIcon={<SendIcon />}
              onClick={handleEdit}
            >
              Update Module
            </Button>
          </div>
        </Paper>
      </Modal>

      {/* Delete Modal */}
      <Modal
        className={classes.middlePosition}
        open={deleteTrainingModule}
        onClose={() => setDeleteTrainingModule(false)}
      >
        <Paper className={classes.profilemodal}>
          <Stack
            direction="row"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <Typography variant="h6" style={{ textAlign: "center" }}>
              Are You Want To Delete Training Module?
            </Typography>
          </Stack>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "24px",
            }}
          >
            <Button
              variant="contained"
              style={{ margin: 10 }}
              onClick={() => setDeleteTrainingModule(false)}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              style={{ margin: 10, backgroundColor: "red" }}
              endIcon={<Delete />}
              onClick={handleDelete}
            >
              Delete
            </Button>
          </div>
        </Paper>
      </Modal>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  main: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    marginTop: 30,
  },
  profilemodal: {
    width: "600px", // Adjusted width to fit form better
    background: "white",
    borderRadius: "20px !important",
    margin: "20px",
    padding: "32px",
  },
  middlePosition: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modalContent: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  cardContent: {
    display: "flex",
    width: "90%",
    justifyContent: "center",
    flexDirection: "column",
  },
}));

const mapStateToProps = (state) => ({});
export default connect(mapStateToProps, {})(TraningModule);